import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { AUTH_ACTIONS } from '../actions/auth.actions';
import { IUserAuthProfile } from '../../services';

export const AUTH_STATE_KEY = 'auth';

export interface IAuthState {
  authenticated: boolean;
  discoveryDocumentLoaded: boolean;
  userProfileLoaded: boolean;
  userProfile: IUserAuthProfile;
}

export const initialState: IAuthState = {
  authenticated: false,
  discoveryDocumentLoaded: false,
  userProfileLoaded: false,
  userProfile: {} as IUserAuthProfile,
};

const _authReducer: ActionReducer<IAuthState> = createReducer<IAuthState>(
  initialState,
  on(AUTH_ACTIONS.initLoginCheck, (state) => ({
    ...state,
    discoveryDocumentLoaded: false,
    userProfileLoaded: false,
  })),
  on(AUTH_ACTIONS.authenticated, (state) => ({
    ...state,
    authenticated: true,
  })),
  on(AUTH_ACTIONS.notAuthenticated, (state) => ({
    ...state,
    authenticated: false,
    userProfileLoaded: false,
    userProfile: {} as IUserAuthProfile,
  })),
  on(AUTH_ACTIONS.login, (state) => ({
    ...state,
    authenticated: false,
  })),
  on(AUTH_ACTIONS.discoveryDocumentLoaded, (state) => ({
    ...state,
    discoveryDocumentLoaded: true,
  })),
  on(AUTH_ACTIONS.userProfileLoaded, (state, { userProfile }) => ({
    ...state,
    userProfileLoaded: true,
    userProfile,
  })),
  on(AUTH_ACTIONS.logout, (state) => ({
    ...state,
    ...initialState,
  })),
);

export const authReducer = (state: IAuthState | undefined, action: Action): IAuthState => _authReducer(state, action);
